import { Container, ContainerProps } from '@chakra-ui/react';
import React from 'react';

export const SectionContainer: React.FC<ContainerProps> = (props) => (
  <Container maxWidth={{ base: '672px', xl: '696px' }} p={0} {...props} />
);
